"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormScreen = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./FormScreen.css"));
var AddProjectTotals_1 = __importDefault(require("../AddProjectTotals"));
var inversify_react_1 = require("inversify-react");
var AddQuoteDetails_1 = __importDefault(require("../Utils/AddQuoteDetails"));
var AcceptFlowContextProvider_1 = require("../AcceptFlowContextProvider");
var Utils_1 = require("./Utils");
var Disclaimer_1 = require("./FormComponents/Disclaimer");
var CustomDetails_1 = require("./FormComponents/CustomDetails");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var lodash_1 = require("lodash");
var PaymentForm_1 = require("./FormComponents/PaymentForm");
var StripeContext_1 = require("./StripeContext");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var pages_common_1 = require("@qwilr/pages-common");
var Esignature_1 = require("./FormComponents/Esignature");
var SecuredByQwilr_1 = require("@CommonFrontend/SecuredByQwilr/SecuredByQwilr");
var SecuredByQwilr_2 = require("../Utils/SecuredByQwilr");
var PrefillContextProvider_1 = require("../Springboard/PrefillContextProvider");
var UserPrefillGhost_1 = require("../Springboard/UserPrefillGhost");
var UserPrefill_1 = require("../Springboard/UserPrefill");
var ESignV3_1 = require("../ESign/ESignV3");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var ValidateInjection_1 = require("./FormComponents/ValidateInjection");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var AcceptFlowGlobalStore_1 = __importDefault(require("../AcceptFlowGlobalStore"));
var LoadingScreen_1 = require("@CommonFrontend/LoadingScreen/LoadingScreen");
var TextField_1 = require("./FormComponents/TextField");
var DEBUG_MODE = false;
var FormContainer = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var onClose = _a.onClose, onBack = _a.onBack, onSubmit = _a.onSubmit, onFinaliseForm = _a.onFinaliseForm, prefillData = _a.prefillData;
    var projectTotal = (0, inversify_react_1.useInjection)("projectTotal");
    var quoteBlocksList = (0, inversify_react_1.useInjection)("quoteBlocksList");
    var visitToken = (0, inversify_react_1.useOptionalInjection)("visitToken");
    var projectCurrencies = (0, inversify_react_1.useInjection)("projectCurrencies");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var isMobile = (0, inversify_react_1.useInjection)("isMobile");
    var _m = __read((0, pages_common_1.usePubSubEvent)("qwilr:quote-total-changed", {
        total: projectTotal.calculatePayTodaySingleCurrency(),
    }), 1), quoteTotal = _m[0].total;
    var _o = __read((0, react_1.useState)(false), 2), isSubmitting = _o[0], setIsSubmitting = _o[1];
    var userOptedOptionalPayment = (0, react_1.useRef)(false);
    var _p = __read((0, react_1.useState)(false), 2), showLoadingScreen = _p[0], setShowLoadingScreen = _p[1];
    var _q = __read((0, react_1.useState)(), 2), loadingError = _q[0], setLoadingError = _q[1];
    var _r = __read((0, react_1.useState)(-1), 2), currentStage = _r[0], setCurrentStage = _r[1];
    var stages = ["Initiating acceptance", "Processing your payment", "Finalising process"];
    var _s = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), isPreviewAccept = _s.isPreviewAccept, settings = _s.settings, autofillEnabled = _s.autofillEnabled, payments = _s.payments, isPrintMode = _s.isPrintMode, disableFormSubmitReason = _s.disableFormSubmitReason, isSimpleMode = _s.isSimpleMode, text = _s.text, showAcceptAndPayValue = _s.showAcceptAndPayValue, formHeaderHidden = _s.hideHeader, accepterIndex = _s.accepterIndex, acceptersDataStore = _s.acceptersDataStore;
    var globalStore = AcceptFlowGlobalStore_1.default.getInstance();
    var formRef = (0, react_1.useRef)();
    var stripeContext = (0, StripeContext_1.useStripeContext)();
    var disableFormSubmit = !!disableFormSubmitReason;
    var hideHeader = isSimpleMode || formHeaderHidden;
    var _t = (0, Utils_1.getPaymentDetails)(payments === null || payments === void 0 ? void 0 : payments.paymentSettings, projectCurrencies, quoteTotal), paymentAmount = _t.paymentAmount, currencyCode = _t.currencyCode, isPartialPayment = _t.isPartialPayment, partialPaymentPercentage = _t.partialPaymentPercentage;
    var hasPayment = !!(payments === null || payments === void 0 ? void 0 : payments.paymentAddedAt);
    var finalisedAccepters = settings.accepters.finalisedAccepters ? settings.accepters.finalisedAccepters.length : 0;
    var incompleteAccepters = settings.accepters.number - finalisedAccepters;
    var paymentEnabled = Boolean(payments) &&
        incompleteAccepters === 1 &&
        !hasPayment &&
        !isPrintMode &&
        (paymentAmount > 0 || (isPreviewAccept && quoteBlocksList.get().length > 0));
    var isGroupAccept = settings.accepters.number > 1;
    var prefilledFields = (0, react_1.useRef)([]);
    var originalName = (0, react_1.useRef)("");
    var _u = (0, pages_common_1.useAuthenticationContext)(), user = _u.user, isSignedIn = _u.isSignedIn;
    var organizationFieldLabel = (0, Utils_1.getSpelledOrganization)(settings.organizationField);
    var showOrganizationField = (_c = (_b = settings.organizationField) === null || _b === void 0 ? void 0 : _b.show) !== null && _c !== void 0 ? _c : true;
    var usePrintStylingV2 = isPrintMode && usingFeature(FeatureFlag_1.default.PrintStylingV2);
    var currentSlotIndex = acceptersDataStore === null || acceptersDataStore === void 0 ? void 0 : acceptersDataStore.accepterIndex;
    (0, react_1.useEffect)(function () {
        if (currentSlotIndex !== null && currentSlotIndex !== undefined && acceptersDataStore) {
            var slotData = acceptersDataStore.accepterSlots[currentSlotIndex];
            if ((slotData === null || slotData === void 0 ? void 0 : slotData.name) && !originalName.current) {
                originalName.current = slotData.name;
            }
        }
        if (currentSlotIndex !== null &&
            currentSlotIndex !== undefined &&
            formRef.current &&
            acceptersDataStore &&
            !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.name)) {
            var slotData = acceptersDataStore.accepterSlots[currentSlotIndex];
            if (slotData && slotData.name && !slotData.name.startsWith("Accepter")) {
                formRef.current.change("name", slotData.name);
            }
        }
    }, [currentSlotIndex]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        var hasPrefillData = prefillData && Object.keys(prefillData).length > 0;
        if (hasPrefillData) {
            Object.entries(prefillData).forEach(function (_a) {
                var _b, _c;
                var _d = __read(_a, 2), key = _d[0], value = _d[1].value;
                (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.change(key, value);
                if (key === "esignature") {
                    (_c = formRef.current) === null || _c === void 0 ? void 0 : _c.change("signatureMethod", ESignV3_1.SignatureInputMethod.Prefilled);
                    if (acceptersDataStore && value) {
                        for (var i = 0; i < acceptersDataStore.accepterSlots.length; i++) {
                            var slot = acceptersDataStore.accepterSlots[i];
                            if (slot) {
                                if (!slot.signature) {
                                    acceptersDataStore.updateSlotSignature(i, value, ESignV3_1.SignatureInputMethod.Prefilled);
                                }
                            }
                        }
                    }
                }
                if (!prefilledFields.current.includes(key)) {
                    prefilledFields.current.push(key);
                }
            });
            if (((_a = prefillData === null || prefillData === void 0 ? void 0 : prefillData.name) === null || _a === void 0 ? void 0 : _a.value) && accepterIndex !== undefined) {
                globalStore.setName(accepterIndex, prefillData.name.value);
            }
            prefilledFields.current = prefilledFields.current.filter(function (field) { return Object.keys(prefillData).includes(field); });
        }
        else {
            var formData_1 = (_b = formRef.current) === null || _b === void 0 ? void 0 : _b.getState().values;
            if (formData_1) {
                (_c = prefilledFields.current) === null || _c === void 0 ? void 0 : _c.forEach(function (field) {
                    delete formData_1[field];
                    if (field === "esignature") {
                        delete formData_1["signatureMethod"];
                    }
                });
                (_d = formRef.current) === null || _d === void 0 ? void 0 : _d.initialize(formData_1);
            }
            if (accepterIndex !== undefined && prefilledFields.current.includes("name")) {
                globalStore.setName(accepterIndex, originalName.current);
            }
            if (accepterIndex !== undefined && prefilledFields.current.includes("esignature")) {
                globalStore.clearAllInitialsAtIndex(accepterIndex);
                globalStore.clearAllSignaturesAtIndex(accepterIndex);
            }
            prefilledFields.current = [];
        }
    }, [prefillData, formRef, prefilledFields]);
    var finalizeLoading = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!isPreviewAccept &&
                        stripeContext.enabled &&
                        !userOptedOptionalPayment.current &&
                        paymentEnabled &&
                        usingFeature(FeatureFlag_1.default.QwilrPayRecurring) &&
                        !loadingError)) return [3, 2];
                    setCurrentStage(2);
                    return [4, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                case 1:
                    _a.sent();
                    setShowLoadingScreen(false);
                    _a.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var errorMessageHandler = function (errorMessage, errorTitle, allowOptions) {
        if (usingFeature(FeatureFlag_1.default.QwilrPayRecurring) && !loadingError) {
            setLoadingError(errorMessage ? { message: errorMessage, title: errorTitle, option: allowOptions } : undefined);
        }
        else {
            return (0, kaleidoscope_1.createFormSubmitErrorObject)(errorMessage);
        }
        return;
    };
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", className: "form-screen" },
        showLoadingScreen && (react_1.default.createElement(LoadingScreen_1.LoadingScreen, { stages: stages, currentStage: currentStage, onDismiss: function () {
                setShowLoadingScreen(false);
                setLoadingError(undefined);
                setCurrentStage(0);
            }, error: loadingError })),
        !isPrintMode && !hideHeader && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.headerStack, justify: "center", direction: "horizontal", align: "center" },
            isGroupAccept && (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ArrowLeft, null), disabled: isSubmitting, isIconOnly: true, onClick: onBack, className: styles.backButton, "aria-label": "Back" })),
            react_1.default.createElement("div", { className: styles.iconContainer },
                react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Large, className: styles.tickIcon, "aria-hidden": true })),
            react_1.default.createElement(kaleidoscope_1.IconButton, { isIconOnly: true, icon: react_1.default.createElement(icons_1.Close, null), onClick: function () {
                    onClose();
                }, disabled: isSubmitting, className: styles.closeButton, "aria-label": "Close" }))),
        !isPrintMode && hideHeader && isGroupAccept && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.headerStack, justify: "center", direction: "horizontal", align: "center" },
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ArrowLeft, null), disabled: isSubmitting, isIconOnly: true, onClick: onBack, className: styles.backButton, "aria-label": "Back" }))),
        !usePrintStylingV2 && (react_1.default.createElement("div", { onClick: function () {
                if (autofillEnabled && formRef.current) {
                    autofill(formRef.current, settings, payments);
                }
            }, "data-qwilr-component": "accept-form-heading", className: "form-screen-heading" },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", align: "center" }, ((_d = prefillData === null || prefillData === void 0 ? void 0 : prefillData.name) === null || _d === void 0 ? void 0 : _d.source) === "blockSettings" ? "Accept for ".concat(prefillData.name.value) : "Accept"))),
        !isPrintMode && !isSimpleMode && (react_1.default.createElement(kaleidoscope_1.Text, { align: "center" }, "To accept this document, fill out the form and click the button below.")),
        !isPrintMode && disableFormSubmitReason === Utils_1.AcceptFormDisabledReason.RequiresQuote && (react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Action required" }, (0, Utils_1.getAcceptFormDisabledMessage)(disableFormSubmitReason))),
        DEBUG_MODE && (react_1.default.createElement("div", { style: { border: "1px solid blue", padding: "2px" } },
            "Prefill Data:",
            react_1.default.createElement("pre", { style: { overflow: "scroll" } }, JSON.stringify(prefillData, null, 2)))),
        !isPrintMode && prefillData && ((_e = prefillData.email) === null || _e === void 0 ? void 0 : _e.value) && (react_1.default.createElement(UserPrefill_1.UserCard, { email: prefillData.email.value, organisation: (_f = prefillData.legalEntity) === null || _f === void 0 ? void 0 : _f.value, profileImageUrl: (_g = user === null || user === void 0 ? void 0 : user.profileImageUrl) !== null && _g !== void 0 ? _g : "", name: ((_h = prefillData === null || prefillData === void 0 ? void 0 : prefillData.name) === null || _h === void 0 ? void 0 : _h.source) === "springboard" ? prefillData.name.value : undefined, signature: (_j = prefillData === null || prefillData === void 0 ? void 0 : prefillData.esignature) === null || _j === void 0 ? void 0 : _j.value })),
        react_1.default.createElement(kaleidoscope_1.FormComponent, { fieldSize: isPrintMode ? "small" : "large", onSubmit: function (formData) { return __awaiter(void 0, void 0, void 0, function () {
                var acceptanceData, addPayment, validatePaymentDetails, error_1, response;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setIsSubmitting(true);
                            if (disableFormSubmit) {
                                return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)((_a = (0, Utils_1.getAcceptFormDisabledMessage)(disableFormSubmitReason)) !== null && _a !== void 0 ? _a : "An unknown error occurred")];
                            }
                            acceptanceData = (0, Utils_1.transformAndCleanFormData)(formData, settings, prefillData);
                            if (accepterIndex !== undefined) {
                                acceptanceData.accepterIndex = accepterIndex;
                            }
                            (0, AddProjectTotals_1.default)(acceptanceData, projectTotal);
                            acceptanceData.isTotalVisible = isPreviewAccept ? false : projectTotal.hasVisibleQuoteTotal();
                            acceptanceData.sessionStartedAt = window.sessionStartTime;
                            (0, AddQuoteDetails_1.default)(quoteBlocksList, acceptanceData);
                            if (visitToken) {
                                acceptanceData.visitToken = visitToken;
                            }
                            if (!(!isPreviewAccept && stripeContext.enabled && !userOptedOptionalPayment.current && paymentEnabled)) return [3, 5];
                            addPayment = stripeContext.addPayment, validatePaymentDetails = stripeContext.validatePaymentDetails;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, , 5]);
                            return [4, validatePaymentDetails()];
                        case 2:
                            _b.sent();
                            if (usingFeature(FeatureFlag_1.default.QwilrPayRecurring)) {
                                setShowLoadingScreen(true);
                                setCurrentStage(0);
                            }
                            acceptanceData.payment = {
                                amount: paymentAmount,
                                currency: currencyCode,
                                name: acceptanceData.name,
                                email: acceptanceData.email,
                            };
                            return [4, addPayment(acceptanceData)];
                        case 3:
                            _b.sent();
                            return [3, 5];
                        case 4:
                            error_1 = _b.sent();
                            errorMessageHandler("Encountered error while processing payment", "Unable to submit payment");
                            setIsSubmitting(false);
                            if (error_1 instanceof Error) {
                                if (error_1.message === "stripe validation error") {
                                    return [2];
                                }
                                if (error_1.message.toLowerCase() === "duplicate payment") {
                                    return [2, errorMessageHandler("A payment has already been submitted by another accepter. Please refresh the page.", "Duplicate payment detected", "refresh")];
                                }
                                if (error_1.message === "Could not create a payment") {
                                    if (quoteTotal === undefined) {
                                        return [2, errorMessageHandler("Cannot submit a payment without a quote.", "Unable to submit payment")];
                                    }
                                    if (quoteTotal < 1) {
                                        return [2, errorMessageHandler("Cannot process a payment for the current amount.", "Unable to submit payment")];
                                    }
                                }
                                return [2, errorMessageHandler(error_1.message, "Unable to submit payment")];
                            }
                            console.error(error_1);
                            return [2, errorMessageHandler("An error occurred while submitting payment details; please try again later.", "Unable to submit payment")];
                        case 5:
                            setCurrentStage(1);
                            return [4, onSubmit(acceptanceData, isSignedIn)];
                        case 6:
                            response = _b.sent();
                            if (!!response) return [3, 8];
                            return [4, finalizeLoading()];
                        case 7:
                            _b.sent();
                            onFinaliseForm();
                            return [3, 9];
                        case 8:
                            if (usingFeature(FeatureFlag_1.default.QwilrPayRecurring)) {
                                errorMessageHandler(response === null || response === void 0 ? void 0 : response["FINAL_FORM/form-error"], "Unable to submit payment");
                            }
                            _b.label = 9;
                        case 9:
                            setIsSubmitting(false);
                            return [2, response];
                    }
                });
            }); }, "data-qwilr-component": "accept-form", className: styles.form({
                isPrintMode: isPrintMode !== null && isPrintMode !== void 0 ? isPrintMode : false,
                isV2PrintStyling: isPrintMode && usingFeature(FeatureFlag_1.default.PrintStylingV2),
                isSimpleMode: isSimpleMode !== null && isSimpleMode !== void 0 ? isSimpleMode : false,
                isMobile: (_k = isMobile()) !== null && _k !== void 0 ? _k : false,
            }) },
            react_1.default.createElement(react_1.default.Fragment, null,
                !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.name) && (react_1.default.createElement(TextField_1.AcceptFormTextField, { isPrintMode: isPrintMode, className: Utils_1.acceptFormFocusableClassname, name: "name", label: "Name", placeholder: "Full name", validate: function (value) {
                        if (!value) {
                            return "Name cannot be empty";
                        }
                        return (0, ValidateInjection_1.validateInjection)(value);
                    }, onChange: function (value) {
                        if (globalStore.currentSlot !== null) {
                            globalStore.setName(globalStore.currentSlot, value);
                        }
                    } })),
                !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.email) && (react_1.default.createElement(TextField_1.AcceptFormTextField, { isPrintMode: isPrintMode, className: Utils_1.acceptFormFocusableClassname, name: "email", label: "Email", placeholder: "name@email.com", type: "email", validate: function (value) {
                        if (!value) {
                            return "Email cannot be empty";
                        }
                        return (0, ValidateInjection_1.validateInjection)(value, { allowUrlsOrEmails: true });
                    } })),
                !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.legalEntity) && showOrganizationField && (react_1.default.createElement(TextField_1.AcceptFormTextField, { isPrintMode: isPrintMode, className: Utils_1.acceptFormFocusableClassname, name: "legalEntity", label: ((_l = settings.organizationField) === null || _l === void 0 ? void 0 : _l.required) ? organizationFieldLabel : "".concat(organizationFieldLabel, " (optional)"), placeholder: "".concat(organizationFieldLabel, " name"), validate: function (value) {
                        var _a, _b;
                        var isRequired = (_b = (_a = settings.organizationField) === null || _a === void 0 ? void 0 : _a.required) !== null && _b !== void 0 ? _b : false;
                        if (isRequired && !value)
                            return "".concat(organizationFieldLabel, " cannot be empty");
                        if (!value)
                            return;
                        return (0, ValidateInjection_1.validateInjection)(value, { allowUrlsOrEmails: true });
                    } })),
                settings.customForm && react_1.default.createElement(CustomDetails_1.CustomDetails, null),
                settings.esignEnabled && !(prefillData === null || prefillData === void 0 ? void 0 : prefillData.esignature) && react_1.default.createElement(Esignature_1.Esignature, { usingFeature: usingFeature }),
                settings.esignEnabled && settings.disclaimer && !isPrintMode && react_1.default.createElement(Disclaimer_1.Disclaimer, null),
                paymentEnabled && (react_1.default.createElement(PaymentForm_1.PaymentForm, { paymentConfiguration: {
                        paymentAmount: paymentAmount,
                        isPartialPayment: isPartialPayment,
                        currencyCode: currencyCode,
                        partialPaymentPercentage: partialPaymentPercentage,
                    } })),
                react_1.default.createElement(kaleidoscope_1.FormContext.Consumer, null, function (context) {
                    if (!context) {
                        throw new Error("FormContext must be inside a FormComponent");
                    }
                    formRef.current = context.form;
                    var submitError = context.submitError, values = context.values;
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !!submitError, timeout: kaleidoscope_1.AnimationDuration.Short, "aria-live": "polite" }, function (_a) {
                            var expandableElementRef = _a.expandableElementRef;
                            return (react_1.default.createElement("div", { ref: expandableElementRef },
                                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.submitError, padding: "m", "aria-live": "polite" }, submitError)));
                        }),
                        DEBUG_MODE && (react_1.default.createElement("div", { style: { border: "1px solid blue", padding: "2px" } },
                            "Form Data:",
                            react_1.default.createElement("pre", { style: { overflow: "scroll" } }, JSON.stringify(values, null, 2))))));
                }),
                !isPrintMode && (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (children) {
                        if (disableFormSubmit) {
                            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: (0, Utils_1.getAcceptFormDisabledMessage)(disableFormSubmitReason), size: kaleidoscope_1.TooltipSize.Large },
                                react_1.default.createElement("div", null, children)));
                        }
                    } },
                    react_1.default.createElement(kaleidoscope_1.FormSubmitButton, { width: "full", className: styles.formSubmitButton, disabled: disableFormSubmit, "data-testid": "accept-form-submit" }, paymentEnabled && showAcceptAndPayValue
                        ? "Accept and Pay ".concat((0, FormatCurrency_1.formatCurrency)(paymentAmount, currencyCode), " ").concat(currencyCode)
                        : text.button),
                    paymentEnabled && (payments === null || payments === void 0 ? void 0 : payments.paymentSettings.requireOnAccept) === false && (react_1.default.createElement(kaleidoscope_1.FormSubmitButton, { width: "full", className: styles.optionalSubmitButton, disabled: disableFormSubmit, "data-testid": "accept-form-submit-with-optional-payment", type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
                            userOptedOptionalPayment.current = true;
                        } }, payments.paymentSettings.payLaterButtonText || "Accept now, pay later")))))),
        !isPrintMode && react_1.default.createElement(SecuredByQwilr_1.SecuredByQwilr, { isMobile: isMobile(), utmParams: SecuredByQwilr_2.acceptFlowMarketingParams })));
};
var FormScreen = function (props) {
    var _a = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), settings = _a.settings, isPrintMode = _a.isPrintMode, telemetry = _a.telemetry;
    var accepterName = props.accepterName, rest = __rest(props, ["accepterName"]);
    var name = accepterName ? { name: accepterName } : undefined;
    var consumerDataServiceUrl = props.consumerDataServiceUrl;
    if (isPrintMode || !consumerDataServiceUrl) {
        return react_1.default.createElement(FormContainer, __assign({}, rest, { prefillData: (0, Utils_1.mapPrefillData)({ blockSettings: name }) }));
    }
    return (react_1.default.createElement(PrefillContextProvider_1.PrefillContextProvider, { esignEnabled: settings.esignEnabled, consumerDataServiceBaseUrl: consumerDataServiceUrl, sellerHasSetName: !!accepterName, acceptTelemetry: telemetry },
        react_1.default.createElement(PrefillContextProvider_1.PrefillContextConsumer, null, function (_a) {
            var loading = _a.loading, springboardPrefill = _a.prefill;
            return loading ? (react_1.default.createElement(UserPrefillGhost_1.UserPrefillGhost, { esignEnabled: settings.esignEnabled })) : (react_1.default.createElement(FormContainer, __assign({}, rest, { prefillData: (0, Utils_1.mapPrefillData)({ springboardData: springboardPrefill, blockSettings: name }) })));
        })));
};
exports.FormScreen = FormScreen;
var autofill = function (form, settings, payments) {
    var textFields = ["name", "legalEntity"];
    var dropdownFields = [];
    if (settings.customForm) {
        settings.customForm.fields
            .filter(function (field) { return field.type === "text"; })
            .forEach(function (field) { return textFields.push("".concat(field.id)); });
        var dropdowns = settings.customForm.fields.filter(function (field) { return field.type === "dropdown"; });
        dropdownFields = dropdowns.map(function (field) { return ({ name: field.id, items: field.items }); });
    }
    if (settings.esignEnabled) {
        form.change("disclaimerAccepted", true);
        if (!form.getState().values["esignature"]) {
            console.log("Cannot auto-fill signature. Please sign manually");
        }
    }
    if (payments === null || payments === void 0 ? void 0 : payments.paymentSettings.enabled) {
        console.log("Cannot auto-fill pay now details. Please use a test card from Stripe: https://stripe.com/docs/testing#cards");
        textFields.push("cardName");
        textFields.push("cardZip");
        if (settings.accepters.number > 1) {
            form.change("email_for_card", "".concat((0, utils_1.randomString)(10), "@testing.com"));
        }
    }
    textFields.forEach(function (field) {
        if (!form.getState().values[field]) {
            form.change(field, (0, utils_1.randomString)(10));
        }
    });
    dropdownFields.forEach(function (field) {
        if (!form.getState().values[field.name]) {
            form.change(field.name, (0, lodash_1.sample)(field.items));
        }
    });
    if (!form.getState().values["email"]) {
        form.change("email", "".concat((0, utils_1.randomString)(10), "@testing.com"));
    }
};
